import {Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild, ElementRef} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl} from '@angular/forms';
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'core-input-text-area',
  templateUrl: 'input-text-area.component.html',
  styleUrls: ['input-text-area.component.scss', '../input.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: InputTextAreaComponent,
    multi: true
  }]
})
export class InputTextAreaComponent implements ControlValueAccessor, OnInit {
  faInfoCircle = faInfoCircle;

  @Input() id: string;
  @Input() label: string;
  @Input() topLabel: string;
  @Input() placeholder = '';
  @Input() showClearButton = true;
  @Input() showRevertButton = false;
  @Input() rows = 5;
  @Input() required = false;
  @Input() infoLabel: string;

  @Input() removeDefaultBottomErrorMargin = false;
  @ViewChild('textarea') textareaElement: ElementRef<HTMLTextAreaElement>;

  @Output() onKeyUpEnter = new EventEmitter<string>();
  @Output() onRevert = new EventEmitter<any>();
  @Output() blur = new EventEmitter<void>();

  control: NgControl;

  value: string;
  disabled = false;
  private onTouched: Function;
  private onChanged: Function;

  constructor(private inj: Injector) {
    if (!this.id) {
      this.id = 'core-input-text-area-' + Math.random();
    }
  }

  ngOnInit() {
    this.control = this.inj.get(NgControl);
  }

  onClear() {
    this.valueChanged(null);
    this.onKeyUpEnter.emit(null);
  }

  valueChanged(value: string) {
    this.onTouched();
    this.value = value;
    this.onChanged(value);
  }

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: Function): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: Function): void {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  onRevertPressed() {
    this.onRevert.emit();
  }

  focus() {
    if (this.textareaElement) {
      const textarea = this.textareaElement.nativeElement;
      textarea.focus();
      const len = textarea.value?.length ?? 0;
      textarea.setSelectionRange(len, len);
    }
  }

}
